import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-consulta-kardex',
  templateUrl: './consulta-kardex.component.html',
  styleUrls: ['./consulta-kardex.component.css']
})
export class ConsultaKardexComponent implements OnInit {


  form: FormGroup ; 
  form1: FormGroup ; 
  form2: FormGroup ; 
  constructor() { }

  ngOnInit() {

    this.form = new FormGroup({
      NumKardex: new FormControl('',Validators.required)
    });

    this.form1 = new FormGroup({
      NumeroDocumento: new FormControl('',Validators.required)
    });
    this.form2 = new FormGroup({
      NumeroDocumento: new FormControl('',Validators.required)
    });
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.form.controls[controlName].hasError(errorName);
  }

  public hasError1 = (controlName: string, errorName: string) => {
    return this.form1.controls[controlName].hasError(errorName);
  }

  public hasError2 = (controlName: string, errorName: string) => {
    return this.form2.controls[controlName].hasError(errorName);
  }

  onBuscar(){

    if(this.form.valid){
      let kardex = this.form.get('NumKardex').value; 
      window.open(environment.URL_APP+'informacion-kardex/'+kardex);
    }
   
  }

  onBuscarDNI(){
    if(this.form1.valid){
      let documento = this.form1.get('NumeroDocumento').value; 
      window.open(environment.URL_APP+'relacion-kardex/'+documento);
    }
  }

  onBuscarRUC(){
    if(this.form2.valid){
      let documento = this.form2.get('NumeroDocumento').value; 
      window.open(environment.URL_APP+'relacion-kardex/'+documento);
    }
  }

 

}
